import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';

import MainBanner from '../../../components/MainBanner';
import GetInTouch from '../../../components/GetInTouch';
import MultiColumnCTAWithDivider from '../../../components/MultiColumnCTAWithDivider';

export default function ContactUsPage({
    global,
    all_branches
}) {
    return (
        <>
            <SeoHead
                page_name={`Contact Us | The global house of tech and transformation recruitment | Lorien | United States`}
                canonical_link={`contact-us`}
                en_gb={false}
                en_us={true}
                
            />
            <MainBanner
                global={global}
                pathPrefix={`us.contact_us_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Contact Us</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
            />
            <GetInTouch
                global={global}
                pathPrefix={`us.contact_us_page.get_in_touch`}
                customClass={`py-5 grayGradientBg`}
                content={
                    <>
                        <h2>Get in Touch!</h2>
                        <p>There are many way to get in touch.</p>
                    </>
                }
                content_2={
                    <>
                        <h3>
                            Send Us Your CV/Resume
                        </h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    </>
                }
                buttonLink={`/us/contact-us/`}
                buttonTitle={`Submit your CV/Resume`}
                popUpModal_1={true}
                popUpModal_1_form_id={`836be365-52e7-4995-88f7-f7fe40ef6cdc`}
                dialog_content_1={
                    <>
                        <h5>Submit your CV/Resume</h5>
                    </>
                }
                post={all_branches}
                successPageUrl={`/us/contact-us/submission-success`}
            />
            <MultiColumnCTAWithDivider
                global={global}
                pathPrefix={`us.contact_us_page.multi_column_cta`}
                customClass={`pt-5 pb-md-4 pb-5`}
                left_content={
                    <>
                        <h2>Get in Touch</h2>
                        <p>Rorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.</p>
                    </>
                }
                right_content={
                    <>
                        <h2>Newsletter Sign up</h2>
                        <p>Rorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.</p>
                    </>
                }
                buttonLink2={`/`}
                buttonLink1={`/us/contact-us/`}
                buttonTitle1={`Contact us`}
                buttonTitle2={`For Candidates`}
                buttonLink2_1={`/`}
                buttonTitle2_1={`For Clients`}
                popUpModal_1={true}
                popUpModal_2={true}
                popUpModal_1_form_id={`5866c24d-50e6-440a-a63c-c0f61fbbc64d`}
                popUpModal_2_form_id={`68c30867-3a4b-4c20-8c79-366994309775`}
                dialog_content_1={
                    <h5>For candidates</h5>
                }
                dialog_content_2={
                    <h5>For clients</h5>
                }
                successPageUrl={`/us/contact-us/submission-success`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    const branches = await Collection('branches_us');

    const all_branches = branches.orderBy('_order').getItems();
    return {
        props: {
            global,
            all_branches
        }
    };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext